<template>
  <div>
    <!-- bottom -->
    <div class="main_bottom">
      <el-row class="mb_nav">
        <el-col :span="6">
          <h5>关于普惠</h5>
          <router-link :to="{ path: '/centerIntroduce' }">平台简介</router-link>
          <!-- <router-link :to="{ path: '/centerNews' }">新闻资讯</router-link>
          <router-link :to="{ path: '/borrowProcess' }">业务流程</router-link>
          <router-link :to="{ path: '/policiesRegulations' }">政策法规</router-link>
          <router-link :to="{ path: '/cooperativePartner' }">合作伙伴</router-link> -->
        </el-col>
        <el-col :span="6">
          <h5>服务范围</h5>
          <!-- <span slot="title"><router-link :to="{ path: '/serviceScope' }">服务模式</router-link></span> -->
          <!-- <router-link :to="{ path: '/borrowProcess' }">借贷服务</router-link> -->
          <!-- <router-link :to="{ path: '/debtTransferProcess' }">债权转让服务</router-link> -->
          <!-- <router-link :to="{ path: '/ecInvestmentProcess' }">股权/资金投资服务</router-link> -->
          <router-link :to="{path:''}">信息登记</router-link>
          <router-link :to="{ path: '' }">法律咨询、法务支持</router-link>
          <router-link :to="{ path: '' }">调研、风险评估提供担保等</router-link>
          <router-link :to="{ path: '' }">调解、仲裁服务</router-link>
        </el-col>
        <el-col :span="6">
          <h5>走进普惠</h5>
          <router-link :to="{path:'/centerAnswer'}">平台问答</router-link>
          <router-link :to="{ path: '/recruitment' }">招贤纳士</router-link>
          <router-link :to="{ path: '/lawStatement' }">法律申明</router-link>
          <router-link :to="{ path: '/contactUs' }">联系我们</router-link>
        </el-col>
        <el-col :span="6">
          <img src="../assets/images/qrcode_bottom.jpg" />
          <div class="bottom_tel"><i class="iconfont">&#xe600;</i>咨询热线: 400 029 7800</div>
          <div class="bottom_mail"><i class="iconfont">&#xe617;</i>联系邮箱: xxph@phjd365.com</div>
        </el-col>
      </el-row>
      <el-row class="main_copyright">
        <el-col :span="24">Copyright &copy; 2018 陕西普惠投融信息服务有限公司 版权所有 <a href="https://beian.miit.gov.cn" target="_blank">陕ICP备18010605号</a>	|
          <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=61040202000453"><img src="../assets/images/icp.png" style="display: inline-block; vertical-align: middle; margin-top: -5px;"/> 陕公网安备 61040202000453号</a>
        </el-col>
      </el-row>
    </div>
    <!-- bottom END -->

    <!-- side buttons -->
    <div class="side_main">
      <el-popover
              placement="left"
              title="服务热线"
              width="150"
              trigger="hover"
              content="400-029-7800">
        <el-button type="primary" slot="reference"><i class="iconfont">&#xe634;</i></el-button>
      </el-popover>
      <el-popover
              placement="left"
              title="微信关注"
              width="150"
              trigger="hover"
              content="400-000-0000">
        <div><img src="../assets/images/qrcode_bottom.jpg" /></div>
        <el-button type="primary" slot="reference"><i class="iconfont">&#xe695;</i></el-button>
      </el-popover>
      <!--
      <el-popover
              placement="left"
              title="QQ客服"
              width="150"
              trigger="hover"
              content="186000000">
        <el-button type="primary" slot="reference"><i class="iconfont">&#xe7a0;</i></el-button>
      </el-popover>
      -->
      <button class="gotop" @click="goTop" ref="btn"><i class="iconfont">&#xe633;</i></button>
    </div>
    <!-- side buttons END -->


  </div>
</template>
<script>
// Go Top scroller
// let timer = null
export default {
  data () {
    return {
      isTop: true,
      timer: null
    }
  },
  mounted () {
    this.needScroll()
  },
  methods: {
    needScroll () {
      let clientHeight = document.documentElement.clientHeight
      let obtn = this.$refs.btn
      window.onscroll = function () {
        let osTop = document.documentElement.scrollTop || document.body.scrollTop
        if (osTop >= clientHeight / 2) {
          obtn.style.display = 'block'
        } else {
          obtn.style.display = 'none'
        }
        if (!this.isTop) {
          clearInterval(this.timer)
        }
        this.isTop = false
      }
    },
    goTop () {
      let self = this
      self.timer = setInterval(function () {
        let osTop = document.documentElement.scrollTop || document.body.scrollTop
        let ispeed = Math.floor(-osTop / 5)
        document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed
        self.isTop = true
        if (osTop === 0) {
          clearInterval(self.timer)
        }
      }, 10)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/MyFooter.vue